import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import moment from 'moment';

const DateDivider = ({ date }) => {
  const isToday = moment(date).isSame(moment(), 'date');
  const dateString = isToday ? 'Today' : moment(date).format('dddd, MMMM Do');

  return (
    <div className='flex-rows' style={{ alignItems: 'center', padding: '0 20px' }}>
      <div style={{ backgroundColor: '#E8E8E8', height: 1, flex: 1, marginRight: 16 }} />
      <Typography style={{ fontSize: 12, fontWeight: 600 }}>{dateString}</Typography>
      <div style={{ backgroundColor: '#E8E8E8', height: 1, flex: 1, marginLeft: 16 }} />
    </div>
  );
};

DateDivider.propTypes = {
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
};

DateDivider.defaultProps = {
  date: new Date()
};

export default DateDivider;
